module.exports = __webpack_public_path__ + "static/footer-e0c5cc95cd7360ec79dbefd24371c50b.svg";